"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var YoutubeIcon = function YoutubeIcon() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "svg-inline--fa fa-youtube fa-w-18",
    "data-icon": "youtube",
    "data-prefix": "fab",
    viewBox: "0 0 576 512"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    d: "M549.65 124.08a68.62 68.62 0 00-48.28-48.6C458.78 64 288 64 288 64S117.22 64 74.63 75.49a68.62 68.62 0 00-48.28 48.6c-11.42 42.86-11.42 132.3-11.42 132.3s0 89.44 11.42 132.3c6.28 23.65 24.78 41.5 48.28 47.82C117.22 448 288 448 288 448s170.78 0 213.37-11.49c23.5-6.32 42-24.17 48.28-47.82 11.42-42.86 11.42-132.3 11.42-132.3s0-89.44-11.42-132.3zM232.15 337.6V175.2l142.73 81.2-142.73 81.2z"
  }));
};

var _default = YoutubeIcon;
exports.default = _default;